import type { CircleElement } from '@/components/canvas/document/publicTypes';
import { elementFillCss, firstShadow, firstStroke } from '@/components/canvas/elements/model';
import { drawShapeText } from '../utils/shapeTextExport';

export async function drawCircle(ctx: CanvasRenderingContext2D, el: CircleElement) {
  const { x, y } = el.layout;
  const { width, height } = el.size;
  const fillColor = elementFillCss(el);
  const stroke = firstStroke(el.appearance);
  const shadow = firstShadow(el.appearance);
  const cx = x + width / 2,
    cy = y + height / 2,
    rx = width / 2,
    ry = height / 2;

  if (shadow) {
    ctx.shadowBlur = shadow.blur;
    ctx.shadowColor = shadow.color;
    ctx.shadowOffsetX = shadow.offsetX;
    ctx.shadowOffsetY = shadow.offsetY;
  }

  ctx.beginPath();
  ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);

  if (fillColor) {
    ctx.fillStyle = fillColor;
    ctx.fill();
  }

  ctx.shadowBlur = 0;
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;

  if (stroke && stroke.width > 0 && stroke.color) {
    ctx.strokeStyle = stroke.color;
    ctx.lineWidth = stroke.width;
    if (stroke.style === 'dashed') ctx.setLineDash([stroke.width * 3, stroke.width * 2]);
    else if (stroke.style === 'dotted') ctx.setLineDash([stroke.width, stroke.width]);
    else ctx.setLineDash([]);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  if (el.data.text) {
    drawShapeText(ctx, el, { x, y, width, height });
  }
}
